// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".coupon-form[data-v-aa148e50]{width:auto}", "",{"version":3,"sources":["webpack://./resources/js/apps/event-landing-page/ui/registration-modal/ModalFooter.vue"],"names":[],"mappings":"AACA,8BACE,UAAF","sourcesContent":["\n.coupon-form {\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
